<template>
	<v-btn :disabled="outOfStock" @click="addBtnAction($event)" tile elevation="0" :small="$vuetify.breakpoint.smAndDown"
		style="max-width: 72px; max-height: 44px" color="black" class="fxt-buy-btn">
		<v-icon :size="$vuetify.breakpoint.smAndDown ? 20 : 24"> fxt-cart </v-icon>
	</v-btn>
</template>

<script>
import webshopMixins from '@/components/webshop/cart/webshop.mixins.js';
import { debounce } from 'lodash-es';

export default {
	mixins: [webshopMixins],
	methods: {
		async addBtnAction(e) {
			this.$store.dispatch('webshop/set', { key: 'addedProductsToCartDialog', value: false });
			await this.$store.dispatch('webshop/set', { key: 'selectedProducts', value: this.prods });
			this.addProductsToSalonCart(this.salons[0]);
		},

		async openSalonSelectDialog(e) {
			e.preventDefault();
			await this.$store.dispatch('webshop/set', { key: 'selectedProducts', value: this.prods });
			this.$store.dispatch('webshop/set', { key: 'productsSalonPickOptions', value: { dialog: true } });
		},
	},
	data() {
		return {
			addedToCartText: false,
			debounceButtonText: debounce(function () {
				this.addedToCartText = false;
			}, 2000)
		};
	},
	computed: {
		outOfStock() {
			var outOfStock = false
			this.prods.forEach(x => {
				if (outOfStock == false) {
					outOfStock = x.onlineStock <= 0
				}
			})
			return outOfStock;
		},

		cartProducts() {
			var prodIds = this.prods.map(p => p.id)
			return this.$store.getters['clickAndCollect/get']('items').filter((x) => prodIds.includes(x.id));
		},

		selectedProductId() {
			return this.$store.getters['webshop/get']('selectedProduct').id || this.$route.params.productId;
		},
	},
	props: {
		prods: {
			type: Array,
			default: null,
		},
	},
};
</script>
<style lang="scss">
.buy-btn {
	display: none;
}
</style>